define('views/components/reseller_product_modal/reseller_product',['require','backbone','text!templates/components/reseller_product_modal/reseller_product.html'],function(require){

    var Backbone = require('backbone');

    var temp = require("text!templates/components/reseller_product_modal/reseller_product.html");
    return Backbone.Marionette.ItemView.extend({
        tagName: 'tr',
        template: _.template(temp),
        className: 'reseller-product-item',

        events: {
            'change input': 'changeAssignCount'
        },


        changeAssignCount: function (event) {

            var product = this.model.get("product");
            var count = this.model.get("count");
            var changedField = event.currentTarget;

            var assignCount = $(changedField).val();

            if (assignCount <= 0) {
                $(changedField).val(0);
            } else {
                if (product.license_type == 1) {
                    $(changedField).val(1);
                } else if ( assignCount > count){
                    $(changedField).val(count);
                }
            }

        }
    });
});
